import React from 'react';
import { Colors } from 'library';
import { Card, PillButton, Row, Stack, Text, Title } from 'library/ui';
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import { ITeacher } from 'models';
import { Selections } from './EditOrCreateNewJobModal';

export default function EditOrCreateNewJob({
    selectedWorkers,
    goToNext,
}: {
    selectedWorkers: ITeacher[];
    goToNext: (selection: Selections) => void;
}) {
    const [selection, setSelection] = React.useState<Selections>();

    return (
        <Stack gap="md">
            <Title size="h2">Invite Teachers</Title>
            <Text weight="bold">
                Selected teachers: <Text weight="regular">{selectedWorkers.map((w) => w.name).join(', ')}</Text>
            </Text>
            <Stack gap="sm">
                <SelectionCard
                    selected={selection === Selections.Create}
                    onClick={() => setSelection(Selections.Create)}
                    title="Create a new job and invite"
                    subtitle="Add job details and invite selected teachers."
                />
                <SelectionCard
                    selected={selection === Selections.Invite}
                    onClick={() => setSelection(Selections.Invite)}
                    title="Invite to existing job"
                    subtitle="Choose an existing job and invite selected teachers."
                />
            </Stack>
            <Row justify="end" fullWidth>
                <PillButton disabled={!selection} onClick={() => goToNext(selection || Selections.Create)}>
                    Next
                </PillButton>
            </Row>
        </Stack>
    );
}

function SelectionCard({
    selected,
    onClick,
    title,
    subtitle,
}: {
    selected: boolean;
    onClick: () => void;
    title: string;
    subtitle: string;
}) {
    return (
        <Card padding="sm" tone="muted" onClick={onClick}>
            <Row gap="sm" align="center">
                {selected ? (
                    <RadioButtonChecked sx={{ color: Colors.secondary }} />
                ) : (
                    <RadioButtonUnchecked sx={{ color: Colors.textSecondary }} />
                )}
                <Stack gap="none">
                    <Text weight="bold">{title}</Text>
                    <Text size="sm" tone="secondary">
                        {subtitle}
                    </Text>
                </Stack>
            </Row>
        </Card>
    );
}
